import { extend } from 'vee-validate';

import { PaymentCardValidator } from '../utilities';

extend('card_type', {
    validate(value, { unsupportedCartTypes }: any) {
        return PaymentCardValidator.validateUnsupportedCardTypes(value, unsupportedCartTypes);
    },
    params: ['unsupportedCartTypes']
});
